module.exports = __webpack_public_path__ + "static/media/pg.650ab00b.svg";